import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useHistory, useParams } from 'react-router';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SessionModel } from '../../models/SessionModel';
import { ApplicationState } from '../../store';
import * as ServContrRenewMdls from '../../models/ServiceContractRenewViewModel';
import * as ServContRenewStore from '../../store/ServiceContractRenew';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect} from 'react';
import { faSave } from '@fortawesome/free-solid-svg-icons';

type MyProps =
    { ServiceContractInfo: ServContrRenewMdls.ServiceContractRenewViewModel } & { SessionState: SessionModel } & typeof ServContRenewStore.actionCreators;

const ServiceContractRenewScreen: React.FunctionComponent<MyProps> = (props: MyProps) => {

    interface ParamTypes {
        oldContractNum: string
    }

    let { oldContractNum } = useParams<ParamTypes>();

    const myHistory = useHistory();
    
    useEffect(() => {       
        props.loadServiceContractRenewInfo(oldContractNum);
    }, []);


    useEffect(() => {        
        if (props.ServiceContractInfo.result == 'RENEW') {
            myHistory.push("/Contract");
            props.resetState();
        } else if (props.ServiceContractInfo.result) {
            alert(props.ServiceContractInfo.result);
        }      
    }, [props]);    

    const btnAction = (item: ServContrRenewMdls.ServiceContractRenewViewModel, e: React.MouseEvent<HTMLButtonElement>) => {
        if (props.SessionState.SelectedAR.creditCardEnabled) {
            props.setInfoForChargeScreen(item.oldContract.id, item.newContract.contractAmount );
            myHistory.push("/ServiceContractRenewCharge");
        } else {
            props.rewewWithNoCharge(item);
        }
    }

    return (
        <Container fluid={true}> 
            <LoadingIcon loading={props.ServiceContractInfo.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            <Card className='service-contract-renew-card'>
                <CardHeader>Old Contract Info</CardHeader>
                <CardBody>
                <Row>
                    <Col xs={4}>
                        <SaLabel Text='Contract #' />
                    {props.ServiceContractInfo.oldContract.id}
                    </Col>
                            <Col xs={4}>
                        <SaLabel Text='Start Date' />
                        <SaDate Value={props.ServiceContractInfo.oldContract.startDate} />
                    </Col>
                    <Col xs={4}>
                        <SaLabel Text='End Date' />
                        <SaDate Value={props.ServiceContractInfo.oldContract.expiryDate} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={4}>
                        <SaLabel Text='Contract $' />
                            <SaCurrency Amount={props.ServiceContractInfo.oldContract.contractAmount} />
                    </Col>
                    <Col xs={4}>
                            <SaLabel Text='Type' />
                            {props.ServiceContractInfo.oldContract.serviceType}                        
                    </Col>
                    <Col xs={4}>                                                
                    </Col>
                    </Row>
                </CardBody>
            </Card>
            <Card className='service-contract-renew-card'>
                <CardHeader>New Contract Info</CardHeader>
                <CardBody>
                    <Row>
                        <Col xs={4}>
                            <SaLabel Text='Contract #' />
                            {props.ServiceContractInfo.newContract.id}
                        </Col>
                        <Col xs={4}>
                            <SaLabel Text='Start Date' />
                            <SaDate Value={props.ServiceContractInfo.newContract.startDate} />
                        </Col>
                        <Col xs={4}>
                            <SaLabel Text='End Date' />
                            <SaDate Value={props.ServiceContractInfo.newContract.expiryDate} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={4}>
                            <SaLabel Text='Contract $' />
                            <SaCurrency Amount={props.ServiceContractInfo.newContract.contractAmount} />
                        </Col>
                        <Col xs={4}>
                            <SaLabel Text='Type' />
                            {props.ServiceContractInfo.newContract.serviceType}                                                
                    </Col>
                        <Col xs={4}>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <div className="service-contract-renew-btndiv">
                {props.ServiceContractInfo.processing ? <span>Processing..</span> : < Button onClick={(e) => btnAction(props.ServiceContractInfo, e)}>Renew</Button>}
                </div>
        </Container>
    );
}

export default connect(
    (state: ApplicationState) => ({ ...{ ServiceContractInfo: state.serviceContractRenewInfoState }, ...{ SessionState: state.sessionState } }),
    ServContRenewStore.actionCreators)(ServiceContractRenewScreen as any);
